//TODO this is copy pastad from svc-grapqhl need to figure out a way to generate this client side
type Maybe<T> = T | null;
type InputMaybe<T> = Maybe<T>;
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
type RequireFields<T, K extends keyof T> = { [X in Exclude<keyof T, K>]?: T[X] } & { [P in K]-?: NonNullable<T[P]> };
/** All built-in and custom scalars, mapped to their actual values */
type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
};

export type ActiveUser = {
  __typename?: 'ActiveUser';
  displayName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type EntityEvent = {
  __typename?: 'EntityEvent';
  entityId: Scalars['String'];
  eventTimestamp: Scalars['String'];
  id: Scalars['ID'];
  type: EntityEventType;
  user: ActiveUser;
};

export enum EntityEventType {
  EntityClosed = 'ENTITY_CLOSED',
  EntityOpened = 'ENTITY_OPENED',
}

export type MutationAccessEntityArgs = {
  entityId: Scalars['String'];
};

export type MutationCloseEntityArgs = {
  entityId: Scalars['String'];
};

export type QueryGetActiveUsersArgs = {
  entityId: Scalars['String'];
};

export type Subscription = {
  __typename?: 'Subscription';
  entityEvents: EntityEvent;
};

export type SubscriptionEntityEventsArgs = {
  entityId: Scalars['String'];
};
